let debugSnowplowDisabled = false;

export function setDebugSnowplowDisabled(disabled: boolean): void {
  debugSnowplowDisabled = disabled;
}

export function isDebugSnowplowDisabled(): boolean {
  return debugSnowplowDisabled;
}
